<template>
  <v-container grid-list-md fill-height>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-center">
        <p class="headline">Forbidden</p>
        <p class="display-3">403</p>
        <v-btn  color="primary" @click="$router.back()">Return</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  layout: "error"
};
</script>

<style lang="scss" scoped>
</style>